import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessRetirementMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-retirement-metadata/business-retirement-metadata.component.abstract';
import { SharedBusinessMetadataV2Component } from '../shared-business-metadata-v2/shared-business-metadata-v2.component';

@Component({
  selector: 'app-business-retirement-metadata-v2',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    CustomDatePipe,
    SharedBusinessMetadataV2Component,
  ],
  templateUrl: './business-retirement-metadata-v2.component.html',
})
export class BusinessRetirementMetadataV2Component extends BusinessRetirementMetadataComponentAbstract {}
